import React from "react";
import classnames from "classnames";
import { Glyphicon } from "react-bootstrap";
import { Link } from "react-router-dom";
import Rating from "react-rating";

import {
  formatDateMedium,
  formatDateTimeLog
} from "../../../../../../../utils/dates";

import ratingIcon from "../../../../../../../assets/images/filled-star.svg";
import emptyRatingIcon from "../../../../../../../assets/images/empty-star.svg";
import styles from "./Reference.scss";

class Reference extends React.Component {
  render() {
    return (
      <div className={styles.memberModerationReference}>
        {this.renderHeader()}
        {this.renderContent()}
      </div>
    );
  }

  renderNotifications(notifications) {
    const list = notifications.map(r => (
      <ol key={r.sent_at.toString()}>{formatDateTimeLog(r.sent_at)}</ol>
    ));

    return list ? <ul>{list}</ul> : "-";
  }

  renderHeader() {
    const approval = this.props.reference.approval;
    return approval && approval.approved
      ? this.renderApprovedHeader()
      : this.renderPendingHeader();
  }

  renderApprovedHeader() {
    const { approval, name } = this.props.reference;

    return (
      <div className={classnames(styles.header, styles.headerGreen)}>
        <span className={styles.text}>Reference: {name}</span>
        <span className={styles.approvedText}>
          Approved on {formatDateMedium(approval.created_at)}
        </span>
      </div>
    );
  }

  renderPendingHeader() {
    const {
      reference,
      approveReference,
      rejectReference,
      sendReminderReference
    } = this.props;

    const { id, name, filled } = reference;

    const approveButton = (
      <button
        className={classnames(styles.button, styles.buttonWhite)}
        onClick={() => approveReference(id)}
      >
        APPROVE
      </button>
    );

    const sendReminderButton = (
      <button
        className={classnames(styles.button, styles.buttonWhite)}
        onClick={() => sendReminderReference(id)}
      >
        SEND REMINDER
      </button>
    );

    const secondaryButton = filled ? approveButton : sendReminderButton;

    return (
      <div className={styles.header}>
        <span className={styles.text}>Reference: {name}</span>
        <div className={styles.actions}>
          <button className={styles.button} onClick={() => rejectReference(id)}>
            REJECT
          </button>
          {secondaryButton}
        </div>
      </div>
    );
  }

  renderContent() {
    return this.props.reference.filled
      ? this.renderApprovedContent()
      : this.renderPendingContent();
  }

  renderApprovedContent() {
    return (
      <div className={styles.content}>
        <div className={styles.questions}>
          {this.renderQuestions()}
          {this.renderContactInfo()}
        </div>
        <div className={styles.skills}>
          <div className={styles.title}>Skills Endorsement</div>
          {this.renderSkills()}
        </div>
      </div>
    );
  }

  renderQuestions() {
    const { check } = this.props.reference;

    let answers = check.answers.map((answer, index) => {
      let question = _.get(answer, "question.question");
      question = question
        ? question.replace("{{reference_name}}", this.props.memberName)
        : null;

      return (
        <div className={styles.question} key={index}>
          <div className={styles.questionTitle}>{question}</div>
          <div className={styles.questionText}>
            <Rating
              fullSymbol={<img src={ratingIcon} className={styles.icon} />}
              emptySymbol={
                <img src={emptyRatingIcon} className={styles.icon} />
              }
              initialRating={answer.value}
              stop={answer.value}
              readonly
              quiet
            />
          </div>
        </div>
      );
    });

    return answers;
  }

  renderContactInfo() {
    const { email, check } = this.props.reference;

    const relationshipId = _.get(check, "reference.relationship_id");
    const relationship =
      _.find(this.props.workRelations, { id: relationshipId }) || {};

    return (
      <div className={styles.contactInfo}>
        <div>
          <span className={styles.contactInfoTitle}>Contact Info: </span>
          <Link to="#" onClick={this.contactApplicant.bind(this)}>
            {email}
          </Link>
        </div>
        <div>
          <span className={styles.contactInfoTitle}>Current Company: </span>
          {check.current_company}
        </div>
        <div>
          <span className={styles.contactInfoTitle}>Together: </span>
          {check.worked_company} for {check.worked_together_for}
        </div>
        <div>
          <span className={styles.contactInfoTitle}>Relationship: </span>
          {relationship.value}
        </div>
        <div>
          <span className={styles.contactInfoTitle}>Comments: </span>
          {check.comments}
        </div>
      </div>
    );
  }

  renderSkills() {
    const skills = _.get(this.props.reference, "check.skills") || [];

    return skills.map((skill, index) => {
      const icon = skill.match ? "ok" : "remove";

      return (
        <div className={styles.skill} key={index}>
          <Glyphicon
            className={classnames(styles.skillIcon, {
              [styles.skillIconGreen]: skill.match
            })}
            glyph={icon}
          />
          {skill.description.name}
        </div>
      );
    });
  }

  renderPendingContent() {
    const { emailed_at, email, notifications } = this.props.reference;

    const emailLink = (
      <Link to="#" onClick={this.contactApplicant.bind(this)}>
        {email}
      </Link>
    );

    let content;

    if (emailed_at) {
      content = (
        <span>
          This reference was emailed to {emailLink} at:
          {this.renderNotifications(notifications)}
        </span>
      );
    } else {
      content = <span>{emailLink} has not been notified yet.</span>;
    }

    return (
      <div className={styles.content}>
        <div className={styles.pendingText}>{content}</div>
      </div>
    );
  }

  contactApplicant() {
    const link = `mailto:${this.props.memberEmail}`;
    const emailWindow = window.open(link, "emailWindow");

    setTimeout(() => {
      if (emailWindow && emailWindow.open && !emailWindow.closed) {
        emailWindow.close();
      }
    }, 0);
  }
}

export default Reference;



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/profile/components/references/reference/Reference.js